import { Rule } from 'antd/lib/form';

import { getFormFieldBuilder } from 'components/components/FormBuilder/utils/FormFieldBuilder';
import { inputTypes } from 'components/components/FormBuilder/utils/constants';
import { MANAGED_STARTUP_NAME_MAX_LENGTH } from 'packages/venture_builder_repository/utils/constants';
import { requiredValidation } from 'utils/constants/validationRules';

export const startupNameRules: Rule[] = [
  { required: true, whitespace: true, message: 'Enter the startup name' },
  { max: MANAGED_STARTUP_NAME_MAX_LENGTH, message: `Up to ${MANAGED_STARTUP_NAME_MAX_LENGTH} characters` },
];

export const contactEmailRules: Rule[] = [
  { required: true, whitespace: true, message: 'Enter the startup contact email' },
  { type: 'email', transform: (value) => value?.trim(), message: 'Enter a valid email' },
];

export const ventureBuilderDescriptionFields = [{
  fields: [getFormFieldBuilder('description', 'Description', inputTypes.textArea)
    .withRules([{ ...requiredValidation, whitespace: true }])
    .withPlaceholder('Enter description').withRows(4)
    .required()
    .build()],
}];

export const ventureBuilderCreateFields = [
  {
    fields: [getFormFieldBuilder('name', 'Venture Builder name')
      .withRules([{ ...requiredValidation, whitespace: true }])
      .withPlaceholder('Enter Venture Builder name').required()
      .build()],
  },
  ...ventureBuilderDescriptionFields,
  {
    fields: [getFormFieldBuilder('firstName', 'First name')
      .withRules([{ ...requiredValidation, whitespace: true }])
      .withPlaceholder('Enter first name').required()
      .build()],
  },
  {
    fields: [getFormFieldBuilder('lastName', 'Last name')
      .withRules([{ ...requiredValidation, whitespace: true }])
      .withPlaceholder('Enter last name').required()
      .build()],
  },
  {
    fields: [getFormFieldBuilder('email', 'Email')
      .withRules([requiredValidation, { type: 'email', transform: (value) => value?.trim(), message: 'Enter a valid email' }])
      .withPlaceholder('Enter email').required()
      .build()],
  },
];
